"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var Container = _styledComponents["default"].div.attrs(function () {
  return {
    className: "container-fluid"
  };
}).withConfig({
  displayName: "VerticalNavigationContainer__Container",
  componentId: "sc-2syy9c-0"
})(["@media (max-width:767px){margin-top:", ";}@media (min-width:768px){margin-top:", ";margin-left:", ";}margin-bottom:1.25rem;"], function (props) {
  return props.loggedIn ? "32px" : "10px";
}, function (props) {
  return props.loggedIn ? "65px" : "10px";
}, function (props) {
  return props.loggedIn ? "60px" : "0";
});
var VerticalNavigationContainer = function VerticalNavigationContainer(_ref) {
  var loggedIn = _ref.loggedIn,
    displayEnvIndicator = _ref.displayEnvIndicator,
    children = _ref.children;
  return _react["default"].createElement(Container, {
    loggedIn: loggedIn,
    displayEnvIndicator: displayEnvIndicator
  }, children);
};
VerticalNavigationContainer.defaultProps = {};
VerticalNavigationContainer.propTypes = {
  /** if the user is logged in */
  loggedIn: _propTypes["default"].bool.isRequired,
  /** if the env indicator is displayed */
  displayEnvIndicator: _propTypes["default"].bool.isRequired,
  /** children to pass to container */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired
};
var _default = VerticalNavigationContainer;
exports["default"] = _default;